import React from 'react'
import { Card } from 'antd'
import { TPerk } from '../../../../context/types'
import { useAuthContext } from '../../../../context/auth'

export type TPerkItemProps = {
	perk: TPerk
}

export default function Perks({ perk }: TPerkItemProps) {
	const {
		img_url,
		description,
		name,
		user_url,
		expert_url,
		available_for_experts,
		available_for_users,
		is_promoted,
	} = perk
	const { auth } = useAuthContext()
	const isAuthorized = !!auth.token

	const redirectToPerkLink = () => {
		const isExpert = auth?.user?.isExpert

		if (available_for_experts && isExpert) {
			window.open(expert_url)
		} else if (available_for_users) {
			window.open(user_url)
		}
	}

	return (
		<Card
			onClick={isAuthorized && redirectToPerkLink}
			hoverable={isAuthorized}
			bordered={false}
			className={`perk-card ${is_promoted ? 'promoted' : ''}`}
			bodyStyle={{ paddingTop: 0 }}
			cover={<img alt={name} src={img_url} className="perk-img" />}
		>
			<Card.Meta title={name} style={{ marginBottom: 10, maxHeight: 20 }} />
			<div className="truncate-text" style={{ height: 65 }}>
				{description}
			</div>
		</Card>
	)
}
